import React from 'react';
import Icon from '../../../components/AppIcon';

const ViewToggle = ({ currentView, onViewChange }) => {
  const views = [
    { id: 'tree', icon: 'GitBranch', label: 'Tree View' },
    { id: 'list', icon: 'List', label: 'List View' },
    { id: 'grid', icon: 'LayoutGrid', label: 'Grid View' }
  ];

  return (
    <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
      {views?.map((view) => (
        <button
          key={view?.id}
          onClick={() => onViewChange(view?.id)}
          className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
            currentView === view?.id
              ? 'bg-card text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          title={view?.label}
        >
          <Icon name={view?.icon} size={16} />
          <span className="hidden md:inline">{view?.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ViewToggle;